import styled from '@emotion/styled';
import Tags from '@base/Tags/Tags';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '../../../styleConstants';

export const StyledTag = styled(Tags)`
  position: absolute;
  left: ${Spacings.SPACING_4B};
  bottom: ${Spacings.SPACING_2B};
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ $isStreamingDisabled }) => $isStreamingDisabled && '#FF0000'};
  border: none;
  background: ${({ $isStreamingDisabled }) =>
    $isStreamingDisabled &&
    'linear-gradient(0deg, rgba(235, 87, 87, 0.10) 0%, rgba(235, 87, 87, 0.10) 100%), var(--color-base-1)'};
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: var(--color-base-1);
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  grid-column: ${({ gridColumn }) => gridColumn};
  flex-direction: ${({ orientation }) =>
    orientation === 'horizontal' ? 'row' : 'column'};
  :hover {
    box-shadow: ${boxShadowGenerator({
      yOffset: Spacings.SPACING_1B,
      blur: Spacings.SPACING_2B
    })};
  }
  transition: box-shadow 0.2s ease-in-out;
`;

export { default as EnrollButton } from './EnrollButton';
